import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertFooter } from '../../../components/AlertFooter';
import { Button } from '../../../components/Button';
import {
  markQuestionnaireAlertSeen,
  useQuestionnaireAlert,
} from '../../../services/inspection';
import { InspectionAlert } from '../InspectionAlert';
import { FormattedMessage } from 'react-intl';

export const FillInAlert: FC = () => {
  const questionnaire = useQuestionnaireAlert();
  const navigate = useNavigate();

  if (!questionnaire) {
    return null;
  }

  return (
    <InspectionAlert open={!!questionnaire}>
      <FormattedMessage
        tagName="div"
        id="Fill.Alert"
        values={{
          title: questionnaire?.payload.questionnaire.title,
          b: (chunks) => <strong>{chunks}</strong>,
        }}
      />
      <AlertFooter>
        <Button variant="text" onClick={markQuestionnaireAlertSeen}>
          <FormattedMessage id="RemindLater" />
        </Button>
        <Button
          onClick={() => {
            markQuestionnaireAlertSeen();
            navigate(`/inspection/${questionnaire?.id}`);
          }}
        >
          <FormattedMessage id="StartNow" />
        </Button>
      </AlertFooter>
    </InspectionAlert>
  );
};
